import { useQuery } from '@tanstack/react-query';
import {
    fetchPracticePatientInsights,
    type PatientInsightsGranularity
} from '../services/practicePatientInsights';
import { PRACTICE_PATIENT_INSIGHTS_KEY } from './queryKeys';

// Backs each PatientInsightsCard's own query - Submissions and Approvals
// fetch independently so they can be viewed at different granularities.
export function usePracticePatientInsights(
    practiceId: string | undefined,
    granularity: PatientInsightsGranularity
) {
    const query = useQuery({
        queryKey: PRACTICE_PATIENT_INSIGHTS_KEY(practiceId ?? '', granularity),
        queryFn: () => fetchPracticePatientInsights(practiceId as string, granularity),
        enabled: Boolean(practiceId),
        staleTime: 60_000
    });

    return {
        buckets: query.data?.buckets ?? [],
        isLoading: query.isLoading,
        isError: query.isError,
        refetch: query.refetch
    };
}
